import { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { T } from '@transifex/react'
import { DashboardProgress } from '../types/dashboard'

const progressBarContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  mt: 2,
  gap: 1,
}

const RequiredProgress = styled(LinearProgress)({
  height: 24,
  borderRadius: 100,
  backgroundColor: colors.greenExtraLight,
  '& .MuiLinearProgress-bar': {
    backgroundColor: colors.greenPrimary,
    borderRadius: 100,
  },
})

type PlatformSetupProgressProps = {
  progress: DashboardProgress
}

const PlatformSetupProgress: React.FC<PlatformSetupProgressProps> = ({ progress }) => {
  const requiredPercentage =
    progress.required.total > 0 ? (progress.required.completed / progress.required.total) * 100 : 0

  const isReadyForLaunch = progress.required.completed === progress.required.total

  return (
    <>
      <Box sx={progressBarContainerStyle}>
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <RequiredProgress variant="determinate" value={requiredPercentage} />
        </Box>
      </Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mt={1}>
        <Typography variant="caption">
          <T
            _str="Progress: {completed}/{total}"
            completed={(progress.required.completed ?? 0).toLocaleString()}
            total={(progress.required.total ?? 0).toLocaleString()}
          />
        </Typography>
        {isReadyForLaunch && (
          <Typography variant="caption">
            <T _str="You're ready to launch!" /> 🎉
          </Typography>
        )}
      </Stack>
    </>
  )
}

export default PlatformSetupProgress
